<template>
  <div>
    <div v-if="seasonType" class="season-page">
      <div class="tab-box">
        <ul class="tab-btn-list">
          <li v-for="(tab, index) in tabList" :key="index" :class="{active: tab.name === currentMenu}">
            <!--<a href="#" @click.prevent="currentTab = index">{{ tab.title }}</a>-->
            <router-link :to="{name: tab.name}">
              {{tab.title}}
            </router-link>
          </li>
        </ul>
      </div>
      <router-view  class="contents"></router-view>
    </div>
    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="String(seasonMsg)" />
    </div>
  </div>
</template>

<script>
import PageComingSoon from '@/components/Common/PageComingSoon';

export default {
  name: 'TicketSeason',
  components: {PageComingSoon},
  data() {
    return {
      tabList: [],
      seasonType: true,
      seasonMsg: this.$store.getters['getSeasonMsg'],
    }
  },
  mounted () {
  },
  methods: {

  },
  created() {
    const menuList = this.$router.options.routes && this.$router.options.routes.filter(x => {
      return x.path === this.$route.matched[0].path ? x : '';
    });
    const subMenuList = menuList[0].children && menuList[0].children.filter(x => {
      if(x.name === 'season') {
        return x.meta && x.meta.title;
      }
    });
    Object.entries(subMenuList[0].children).forEach(([, value]) => {
      const result = {
        title: value.meta.title,
        name: value.name,
        isActive: this.$route.name === value.name
      }
      this.tabList.push(result);
    });
  },
  computed: {
    currentMenu() {
      return this.$route.name;
    }
  }
}
</script>
